import React from 'react';
import { observer } from "mobx-react";
import moment from 'moment'
import Highcharts from 'highcharts/highstock'

import HighchartWithLoadingSpinner from './HighchartWithLoadingSpinner';
import FigureCaption from '../components/FigureCaption';
import {stateCovidDataStore} from '../store/apiStores'


function createSeriesData(data) {
    let hospitalData = []
    if (data) {
        data.forEach(function(v){
            let date = parseInt(moment.utc(v.report_date).format('x'))
            hospitalData.push([date, v.hospitalized_currently])
        });
    }
    return [
        {
            name: 'Hospitalized',
            data: hospitalData.sort(),
            color: '#BB301A'
        }
    ]
}

function thirtydaysago(data) {
    if (!data || data.length == 0 || !data[0].data || data[0].data.length == 0) {
        // data hasn't loaded yet
        return null;
    }
    let last_dates = []
    data.forEach(function(v){
        v.data.sort()
        last_dates.push(v.data[v.data.length - 1][0])
    });
    let last_day = Math.max(...last_dates)
    return(last_day - ((24*60*60*1000) * 30))
}

export default observer(function StateHospitalSpline(props) {
    let seriesData = createSeriesData(stateCovidDataStore.data);

    let options = {
        chart: {
            type: 'spline',
            zoomType: 'x',
            animation: false
        },

        title: {
            text: `${props.state} State Hospitalization`,
            align: 'left'
        },

        subtitle: {
            text: 'Individuals hospitalized with COVID-19',
            align: 'left'
        },

        time: {
            useUTC: true
        },

        yAxis: {
            opposite: true,
            title: {
                enabled: false
            }
        },

        xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
                month: '%e. %b',
                year: '%b'
            }
        },

        tooltip: {
            pointFormatter: function() {
                return this.series.name + ': <b>' + Highcharts.numberFormat(this.y,0) + '</b>';
            }
        },

        plotOptions: {
            series: {
                label: {
                    enabled: false
                },
                marker: {
                    enabled: false
                }
            },
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        max: null,
                        min: thirtydaysago(seriesData)
                    }
                }
            }]
        },

        series: seriesData
    }

    return (
        <div>
            <HighchartWithLoadingSpinner loaded={stateCovidDataStore.data}
                options={options} dataLength={seriesData && seriesData[0] && seriesData[0].data.length} />
            <FigureCaption short_caption={''} caption={'Individuals currently hospitalized with COVID over time. Data from COVID Tracking Project.'} />
            <br />
        </div>
    )
})
